import Category from "./Category";
import {SiteType} from "./Link";

// A linking site is never "mentions" - SiteType (used by links) stays 3-valued.
// Only packages carry the extra branch, which is why it gets its own union.
export const MENTIONS_SITE_TYPE = 'mentions';
export type PackageSiteType = SiteType | typeof MENTIONS_SITE_TYPE;


interface BasePackage {
    id: string;
    name: string;
    linksCount: number;
    category: Category;
    subCategories: Category[];
    price: number;
    type: 'package';
    thumbnail?: string;
    info: {
        title?: string;
        description?: string;
        bullets?: string[];
        oldPrice?: number;
        discountPercentage?: number;
    };
    emphasize?: {
        title: string;
        color: string;
        enabled: boolean;
        badge?: string;
    };
}

export interface PremiumPackage extends BasePackage {
    siteType: SiteType.PREMIUM;
    links: {
        id: string;
        website: string;
    }[];       // required when premium
}

export interface StandardPackage extends BasePackage {
    siteType: SiteType.SUPER_REGO | SiteType.BOOST
}

// AI Mentions packages: linksCount is a quantity of mentions, and there are no
// links to attach. The catalog the mentions are fulfilled from is a link
// SiteType - the backend requires it on every mentions package.
export interface MentionsPackage extends BasePackage {
    siteType: typeof MENTIONS_SITE_TYPE
    // optional on the wire: packages created before the field existed come back without it
    mentionsCatalogSiteType?: SiteType
}

type Package = PremiumPackage | StandardPackage | MentionsPackage;

export default Package